export enum PartnerFeedbackOptions {
  MISSING_MATERIALS = 'missing-materials',
  // OUTSIDE_SCOPE = 'outside-scope',
  // MATERIALS_DEADLINE_NOT_ACHIEVED = 'materials-deadline-not-achieved',
  CONTACT_SUPPORT = 'contact-support'
}